import React from "react";
import { Link } from "react-router-dom";
import ColumnsWithClickableImage from "components/ColumnsWithClickableImage";
import shopPhoto from "images/shop-floor.jpg";
import furnacePhoto from "images/furnace.jpg";

const CapabilitiesOverview = () => (
  <div className="section is-medium">
    <ColumnsWithClickableImage
      title="CNC Machining"
      imgSrc={shopPhoto}
      imgAlt="Accratronics Shop Floor"
    >
      <p>
        Accratronics is a full-service machine-shop, capable of creating any
        part our clients need, from{" "}
        <Link to="/materials">just about any material</Link> on earth.
      </p>
      <br />
      <p>
        Whether the job requires large-scale CNC operations, precision EDM, or
        the classic craftsman's touch of a DoAll band saw, chances are,{" "}
        <Link to="/equipment">we've got the tools</Link> to take care of it.
      </p>
      <br />
      <p>
        For the last half-century, we've been perfecting the craft of precision
        machining, adapting alongside new technologies, and the ever-increasing
        needs of the most demanding industries there are—on and off earth.
      </p>
      <br />
      {/*<br />*/}
      <Link className="button is-brand" to="/cnc">
        Learn more about our CNC capabilities
      </Link>
    </ColumnsWithClickableImage>
    <hr />
    <ColumnsWithClickableImage
      title="Hermetic Seals"
      imgSrc={furnacePhoto}
      imgAlt="Our CalAlloy Glass Sealing Furnace"
    >
      <p>
        Creating airtight, glass-to-metal hermetic seals is what we do best.
        More than just another mom & pop machine shop (though we are an{" "}
        <em>excellent</em> machine shop), we are the first choice for hermetic
        seals for companies who need the very best.
      </p>
      <br />
      <p>
        We've been cooking up the world's finest glass-to-metal sealed
        connectors <Link to="/about">since 1964</Link>, and our old CalAlloy
        furnace has consistently given us connectors capable of passing a helium
        leak test of 1x10<sup>-8</sup>.
      </p>
      <br />
      {/*<br />*/}
      <Link className="button is-brand" to="/glass-seals">
        Learn more about our Hermetic Seals
      </Link>
    </ColumnsWithClickableImage>
  </div>
);

export default CapabilitiesOverview;



// WEBPACK FOOTER //
// ./src/pages/Home/components/CapabilitiesOverview.js